import { render, staticRenderFns } from "./CmInputTypeCheckbox.vue?vue&type=template&id=212ecd64&"
import script from "./CmInputTypeCheckbox.vue?vue&type=script&lang=js&"
export * from "./CmInputTypeCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports